import type { Node } from 'react'
import React from 'react'
import { NotFound } from 'app/not-found'
import { Error } from 'app/error'

type Props = {
    error?: any,
    networkError?: any,
    children?: Node
}

const ErrorManagement = (props: Props) => {
    const { error, networkError = null, children } = props
    if (error && error.response && error.response.status === 404) {
        return <NotFound />
    }
    return networkError ? (
        <Error networkError={networkError} />
    ) : (
        children || null
    )
}

export { ErrorManagement }
